
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';

import FormField from '@/components/forms/FormField.vue';

import { Getters } from '@/store/enums/SystemEnums';

/**
 * TODO:
 *
 * Recreate this component when the backend start creating auto-generated
 * passwords
 */

export default defineComponent({
  name: 't2o-state-select',
  components: {
    FormField,
  },
  emits: ['change', 'close'],
  props: {
    containerClass: {
      default: 'col-lg-4',
      type: String,
    },
    name: {
      default: 'state',
      type: String,
    },
    label: {
      default: 'State',
      type: String,
    },
    value: {
      default: '',
      type: String,
    },
    options: {
      default: null,
      type: Array,
    },
  },
  computed: {
    ...mapGetters({
      states: Getters.GET_LIST_STATES,
    }),
  },
  methods: {
    handleChange(value) {
      this.$emit('change', value);
    },
    handleClose() {
      this.$emit('close');
    },
  },
});
